module.exports = __webpack_public_path__ + "static/img/icon_snb_map_main.0681943.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_snb_map_main.svg
// module id = 9B6v
// module chunks = 10